class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach(animation => animation.play());
    } else {
      this.animations.forEach(animation => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.hoverMedia = window.matchMedia('(min-width: 1360px) and (hover: hover) and (pointer: fine)');
    this.closeTimer = null;
    this.boundSetDesktopHeaderOffset = this.setDesktopHeaderOffset.bind(this);

    this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    this.summary.addEventListener('click', this.boundSetDesktopHeaderOffset);
    window.addEventListener('resize', this.boundSetDesktopHeaderOffset);
  }

  setDesktopHeaderOffset() {
    if (!this.header) return;

    const headerBottom = Math.floor(this.header.getBoundingClientRect().bottom);
    document.documentElement.style.setProperty('--header-bottom-position-desktop', `${headerBottom}px`);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (this.mainDetailsToggle.open) {
      this.setDesktopHeaderOffset();
    }
  }

  onMouseEnter() {
    if (!this.hoverMedia.matches) return;
    clearTimeout(this.closeTimer);
    document.querySelectorAll('header-menu').forEach((menu) => {
      if (menu !== this && typeof menu.close === 'function') menu.close();
    });
    this.setDesktopHeaderOffset();
    this.mainDetailsToggle.open = true;
    this.summary.setAttribute('aria-expanded', true);
  }

  onMouseLeave() {
    if (!this.hoverMedia.matches) return;
    this.closeTimer = setTimeout(() => this.close(), 120);
  }
}

customElements.define('header-menu', HeaderMenu);
